/**
 * Admin Locations Management - Olympic Fit Wellness
 */
import { useState, useEffect } from 'react';
import { 
  MapPin, 
  Plus,
  Search,
  Edit,
  Trash2,
  Phone,
  Mail,
  Clock
} from 'lucide-react';

export default function LocationsAdminPage() {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadLocations();
  }, []);

  const loadLocations = async () => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      setLocations(mockLocations);
    } catch (error) {
      console.error('Error loading locations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const mockLocations = [
    { location_id: 'loc_mckinney', name: 'Olympic Fit McKinney', address: '1100 N Central Expy', city: 'McKinney', state: 'TX', phone: '(469) 555-0100', members: 12450, is_active: true },
    { location_id: 'loc_frisco', name: 'Olympic Fit Frisco', address: '5500 Eldorado Pkwy', city: 'Frisco', state: 'TX', phone: '(469) 555-0101', members: 15670, is_active: true },
    { location_id: 'loc_plano', name: 'Olympic Fit Plano', address: '3200 Preston Rd', city: 'Plano', state: 'TX', phone: '(469) 555-0102', members: 10230, is_active: true },
    { location_id: 'loc_dallas', name: 'Olympic Fit Dallas', address: '2100 Ross Ave', city: 'Dallas', state: 'TX', phone: '(469) 555-0103', members: 14081, is_active: true },
    { location_id: 'loc_allen', name: 'Olympic Fit Allen', address: '1500 N Greenville Ave', city: 'Allen', state: 'TX', phone: '(469) 555-0104', members: 8500, is_active: false }
  ];

  return (
    <div className="space-y-6" data-testid="locations-admin">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-heading font-bold text-white">Locations</h1>
          <p className="text-neutral-400">Manage gym locations</p>
        </div>
        <button className="inline-flex items-center justify-center gap-2 bg-[#3B82F6] text-white font-semibold px-6 py-3 text-sm tracking-wider hover:bg-blue-600 transition-colors">
          <Plus className="w-4 h-4" />
          ADD LOCATION
        </button>
      </div>

      {/* Locations Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {isLoading ? (
          <div className="col-span-full flex justify-center py-12">
            <div className="w-10 h-10 border-4 border-[#3B82F6] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : locations.map((location) => (
          <div key={location.location_id} className="bg-neutral-800 rounded-xl border border-neutral-700 overflow-hidden">
            <div className="aspect-video bg-neutral-700">
              <img 
                src={`https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600`}
                alt={location.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold text-white">{location.name}</h3>
                  <p className="text-sm text-neutral-400 flex items-center gap-1 mt-1">
                    <MapPin className="w-4 h-4" />
                    {location.city}, {location.state}
                  </p>
                </div>
                <span className={`px-2 py-1 text-xs font-medium rounded ${
                  location.is_active ? 'bg-green-500/20 text-green-400' : 'bg-neutral-600 text-neutral-400'
                }`}>
                  {location.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              
              <div className="space-y-2 text-sm mb-4">
                <p className="text-neutral-400">{location.address}</p>
                <p className="text-neutral-400 flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  {location.phone}
                </p>
                <p className="text-neutral-400">
                  <span className="text-white font-medium">{location.members.toLocaleString()}</span> members
                </p>
              </div>
              
              <div className="flex gap-2">
                <button className="flex-1 px-4 py-2 bg-neutral-700 text-white text-sm font-medium rounded-lg hover:bg-neutral-600 transition-colors flex items-center justify-center gap-2">
                  <Edit className="w-4 h-4" />
                  Edit
                </button>
                <button className="px-4 py-2 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 transition-colors">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
